import { InjectionToken } from '@angular/core';

import { PermanentStorageService } from '@guardfinder/permanent-storage';

import { Consent } from '../../../Domain/Model/Consent/consent';

export const firebaseAnalyticsStorageKey = 'analytics-consent-storage';
export const firebaseAnalyticsConsentStorage = new InjectionToken<PermanentStorageService<Consent>>(
    firebaseAnalyticsStorageKey
);
